export const DataPayloadLinkType = {
  AGENT_RESOURCE: 'AgentResource',
} as const;

export const CHAT_AGENTS_PATH_BASE = 'agents';

export const AI_ACTIONS_PATH_BASE = 'actions';
